module.exports = __webpack_public_path__ + "media/assets/images/tour/5b_Tour_4-ecf6953e4035612be203f5c48e3e7be4.png";